import 
	React,
	{
		useRef, 
		useState, 
		useEffect, 
		useContext,
		createElement 
	}										from "react";
import {
	Form, 
	Col, 
	Row 
}											from "react-bootstrap";
import {baseMaps}							from "../data/baseMaps";
import {overlayMaps}						from "../data/overlayMaps";
import {
	MapTrifold,
	Stack  
}											from "@phosphor-icons/react";
import globalContext						from "../utils/globalContext";

export default function LayerPanel({
	selectedBaseLayer,
	view3d,
	onChange,
}) {
	
	
	const context														= useContext(globalContext);
	const tc = context.tc;
	const [selectedOverlay, setSelectedOverlay]							= useState(null);
	const [selectedBasemap, setSelectedBasemap]							= useState(selectedBaseLayer ? selectedBaseLayer : 0);
	const [selectedBasemapOption, setSelectedBasemapOption]				= useState(selectedBaseLayer ? selectedBaseLayer : 1);
	
	const baseMapsList = baseMaps;
	const project = context.getters?.project
	
	baseMapsList[0]['onClick'] = (e)=>{setView3d(e)};
	
	useEffect(() => {
		setSelectedBasemap(selectedBaseLayer ? selectedBaseLayer : 1);
		
		return () => {
			
		};
	}, [selectedBaseLayer]);
	

	const changeLayer = (opc, e) => {

		if(selectedBasemapOption == opc)
			return false;

		const prev =  selectedBasemapOption;
		setSelectedBasemapOption(opc);
		onChange(opc, ()=>{
			if(prev == 0){
				view3d.exit(e);
			}
		});
	};

	const setView3d = (e) => {

		if(!selectedBasemapOption)
			return false;
		setSelectedBasemapOption(0);
		onChange(2, ()=>{view3d.view3d(e)});
	}

	const handleChangeOverlay = (i) => {

		if(!tc?.scenario?.scenario_id)
			return;


		if(selectedOverlay == i) // it's the same mode, so we just exit
			return setSelectedOverlay(null);

		setSelectedOverlay(i);

	}



	return (<>
		{
			(selectedOverlay != null ? createElement(overlayMaps.overlays[selectedOverlay].handler, { onClose: () => setSelectedOverlay(null) }) : '' )
		}
		<div className="layer-panel" >
			<div className="separator">
				<Stack size={16} weight="bold" /> Map overlays
			</div>
			<div className="section">
				<div className="overlays">

					<div className={"alternatives " + (!tc?.scenario?.scenario_id ?  "disabled" : "") }>
						{
							overlayMaps.overlays.map((a, k)=>{
								return (<div key={k} className={"layer_wrp "+(k == selectedOverlay ? "selected" : "")}><div style={{backgroundImage:'url(/images/'+a.thumbnail+')'}} onClick={(e)=>{handleChangeOverlay(k, e);}} className="layer">{a.label}</div></div>)
							})
						}
					</div>
				</div>
			</div>
			<div className="separator mt-3">
				<MapTrifold size={16} weight="bold" />Base map
			</div>
			<div className="section">
				<div className="current">
					<div className="layer" value={selectedBasemapOption} style={{backgroundImage:'url(/images/'+baseMaps[selectedBasemapOption].thumbnail+')'}}>
						{baseMaps[selectedBasemapOption].label}
					</div>
				</div>
				<div className="alternatives">
					{
					baseMapsList.map((a, k)=>{
						if(k == selectedBasemapOption)
							return;
						if((!a.country || (a.country && a.country == project?.country)))
							return (<div key={k} className="layer_wrp"><div style={{backgroundImage:'url(/images/'+a.thumbnail+')'}} onClick={a.onClick ? a.onClick : (e)=>{changeLayer(k, e)}} className="layer">{a.label}</div></div>)})
					}
				</div>
				
			</div>
		</div>
	</>);
	
}

